module.exports = __webpack_public_path__ + "img/Group 958t1.54556589.svg";